<template>
  <Modal :id="'cmp-add-user'" @cancelled="onCancel">
    <template slot="header">
      {{$t('create')}} {{ isExternal ? $t('external') : "" }} {{$t('user')}}
    </template>
    <template slot="body">
      <div class="form-group login-white">
        <TextField
          class="m1"
          :id="'new_username'"
          required
          v-bind="textFieldConfig"
          v-model="username"
          isModel
          :placeholder="$t('user_name')"
          :autocomplete="'off'"
        ></TextField>
        <TextField
          class="m1"
          :id="'new_password'"
          required
          v-bind="textFieldConfig"
          v-model="password"
          isModel
          :password="true"
          :placeholder="$t('password')"
        ></TextField>
        <TextField
          class="m1"
          :id="'new_email'"
          required
          v-bind="textFieldConfig"
          v-model="email"
          isModel
          :placeholder="$t('email_1')"
        ></TextField>
        <Dropdown
          :options="systemLanguagesTV || []"
          :selected="selectedLanguage"
          class="m2"
          :placeholder="$t('language')"
          v-on:selectedChange="(e) => (selectedLanguage = e)"
          :listHeight="95"
          box
        ></Dropdown>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button class="dt-button v1 with-ico s6" @click.stop="onAddUser">
        <!-- <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div> -->
        <div class="button-text">
          {{ $t("add_new_user") }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { mapGetters } from "vuex";

export default {
  components: {
    Modal,
  },
  props: {},
  data: function () {
    return {
      username: "",
      password: "",
      email: "",
      selectedLanguage: null,

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
      // Mark: Data
    };
  },
  watch: {
    systemLanguagesTV: {
      immediate: true,
      handler: function (to, from) {
        if (to) {
          this.selectedLanguage = to[0];
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      systemLanguagesTV: "systemLanguagesTV",
    }),
    user: function () {
      return {
        user_name: this.username,
        password: this.password,
        staff_email: this.email,
        language: this.selectedLanguage.value,
      };
    },
    isExternal: function () {
      return (
        this.$route.query["external"] == "true" ||
        this.$route.query["external"] == true
      );
    },
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onAddUser: function () {
      this.$emit("added", this.user);
    },
    // Mark: Methods
  },
};
</script>

<style lang="scss" scoped>
</style>
